import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
export function Confidence() {
  return <section className="w-full bg-navy px-4 py-16 md:py-24" data-id="element-129" data-mp="12ctjuwvb6mw8">
      <div className="mx-auto max-w-3xl text-center" data-id="element-130" data-mp="16dlwm03e39x9">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-navy-3" data-id="element-131" data-mp="16fzqi5mc2g38">
          <ShieldCheckIcon className="h-10 w-10 text-cyan" aria-hidden="true" data-id="element-132" data-mp="1bavkvcf1lfji" />
        </span>
        <p className="mt-6 font-display text-sm font-extrabold uppercase tracking-wide text-cyan md:text-base" data-id="element-133" data-mp="1g9yn6p3n17ns">
          Your purchase, your decision
        </p>
        <h2 className="mt-3 text-balance font-display text-[32px] font-black leading-[1.05] tracking-tight text-white md:text-5xl" data-id="element-134" data-mp="1q2xggka2xmdq">
          Make an Informed Decision About Your Educational Resources
        </h2>
        <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-white/75 md:text-lg" data-id="element-135" data-mp="1z43wytcqax6z">
          <p data-id="element-136" data-mp="242f4gxfjwvm1">I want you to understand what you’re purchasing before you make your decision.</p>
          <p data-id="element-137" data-mp="3iz40t3386aj7">Your purchase includes the digital materials specifically listed on the checkout page.</p>
          <p data-id="element-138" data-mp="3dyg9egb33rog">
            You’ll be able to review the educational references, explore the assessment frameworks, and evaluate the
            documentation templates included in the collection.
          </p>
        </div>
        <p className="mt-6 rounded-2xl bg-navy-2 p-5 text-left text-[15px] leading-relaxed text-white/80" data-id="element-139" data-mp="350mjbn3wxu9q">
          <strong className="text-white" data-id="element-140" data-mp="5l9368v139tb">Refund policy:</strong> Review the applicable eligibility requirements, request
          procedure, and deadline displayed at checkout before purchasing.
        </p>
        <div className="mt-10" data-id="element-141" data-mp="3su5tua0mfwr2">
          <CTAButton label="Get access to the complete collection" sub="One-time payment · $27 USD" data-id="element-142" data-mp="3ny79cxieyyvx" />
        </div>
      </div>
    </section>;
}